import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "31",
  height: "31",
  viewBox: "0 0 31 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19.4928 9.33337L15.4999 13.3263L11.507 9.33337L9.33325 11.5071L13.3262 15.5L9.33325 19.493L11.507 21.6667L15.4999 17.6738L19.4928 21.6667L21.6666 19.493L17.6737 15.5L21.6666 11.5071L19.4928 9.33337ZM15.4999 0.083374C6.9745 0.083374 0.083252 6.97462 0.083252 15.5C0.083252 24.0255 6.9745 30.9167 15.4999 30.9167C24.0253 30.9167 30.9166 24.0255 30.9166 15.5C30.9166 6.97462 24.0253 0.083374 15.4999 0.083374ZM15.4999 27.8334C8.70117 27.8334 3.16659 22.2988 3.16659 15.5C3.16659 8.70129 8.70117 3.16671 15.4999 3.16671C22.2987 3.16671 27.8333 8.70129 27.8333 15.5C27.8333 22.2988 22.2987 27.8334 15.4999 27.8334Z",
      fill: "black"
    }, null, -1)
  ])))
}
export default { render: render }